import type { FC, ReactNode } from 'react';
import { lazy, Suspense, useEffect, useState } from 'react';

import { useConfigSlice } from '../../store/slices/config/selectors';
import { useInitializationSlice } from '../../store/slices/initialization/selectors';
import { useSubtitlesSlice } from '../../store/slices/subtitles/selectors';

const SubtitlesConnected = lazy(() => import('./SubtitlesConnected'));

export const SubtitlesLazyConnected: FC = (): ReactNode => {
  const isReadyToRender = useInitializationSlice.getIsReadyToRender();
  const isSubtitlesAvailable = useConfigSlice.isSubtitlesAvailable();
  const isSubtitlesEnabled = useSubtitlesSlice.getIsEnabled();

  const [loadSubtitles, setLoadSubtitles] = useState(false);
  useEffect(() => {
    if (isReadyToRender && isSubtitlesAvailable && isSubtitlesEnabled) {
      setLoadSubtitles(true);
    }
  }, [isReadyToRender, isSubtitlesAvailable, isSubtitlesEnabled]);

  return !loadSubtitles ? null : (
    <Suspense fallback={<></>}>
      <SubtitlesConnected />
    </Suspense>
  );
};
